// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-3cb4ef1c]{display:none}@media(min-width:1024px){.sf-header__logo[data-v-3cb4ef1c]{width:100%;height:100%;align-items:center;justify-content:center;display:inline-flex}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
